import { formatWhen } from '../lib/watch-format.js';

/**
 * The answers given to a Watch event so far, as the portal composed them (the same text on the feed, the
 * event page and the review page): who, Yes or No, and when. `resolved` is the sentence that says a Yes
 * already settled the question while a No is still welcome. Renders nothing when there is nothing to say.
 */
export default function WatchAnswers({ answers, resolved = null, heading = 'Answers so far' }) {
  const list = Array.isArray(answers) ? answers : [];
  if (list.length === 0 && !resolved) return null;
  return (
    <section className="space-y-2" aria-label={heading} data-testid="watch-answers">
      <h3 className="text-sm font-semibold text-slate-900">{heading}</h3>
      {list.length > 0 ? (
        <ul className="space-y-1 text-sm">
          {list.map((a, i) => (
            <li key={`${a.at}-${i}`} className="break-words">
              <span className={a.answer === 'no' ? 'font-medium text-red-700' : 'text-slate-900'}>{a.text}</span>
              <span className="text-slate-600">, {formatWhen(a.at)}</span>
            </li>
          ))}
        </ul>
      ) : null}
      {resolved ? <p className="text-sm text-slate-700">{resolved}</p> : null}
    </section>
  );
}
